import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Header } from 'formlabs-web-components/Type';
import { Grid, Cell, Section } from 'formlabs-web-components/Grid';
import { Spinner } from 'formlabs-web-components/Navigation';
import { Button } from 'formlabs-web-components/Link';
import { Picture } from 'formlabs-web-components/Media';

import CenterModal from '../modal/CenterModal';
import Price from './Price';

import './ProductOptionModal.module.css';

const ProductOptionModal = ({
  title,
  price,
  link,
  description,
  images,
  cdnUrl,
  loading
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = e => {
    e.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <button styleName="modal" onClick={handleOpen}>
        {t('More Info')} <i className="fl-arrow-right" />
      </button>
      {open && (
        <CenterModal onClose={handleClose} width="800px">
          <Grid direction="x" gutters="margin">
            <Cell largeSize={24}>
              <Header level={4} displayAs={4} weight={600}>
                {title}
              </Header>
              <Price styleName="price" price={price} />
            </Cell>
          </Grid>
          {loading ? (
            <Spinner size={3} color="#0762c8" />
          ) : (
            <>
              {images && (
                <Section
                  id="images"
                  padding="2rem 0 1rem 0"
                  paddingMedium="2rem 0 1rem 0"
                  paddingSmall="2rem 0 1rem 0"
                >
                  <Grid gutters="margin" direction="x">
                    {images.slice(0, 2).map(image => {
                      return (
                        <Cell
                          smallSize={12}
                          backgroundColor="light-grey"
                          styleName="image"
                        >
                          <Picture
                            largeImage={`${cdnUrl}${image.file}`}
                            lazyload={false}
                          />
                        </Cell>
                      );
                    })}
                    {images.length === 1 && (
                      <Cell
                        smallSize={12}
                        backgroundColor="light-grey"
                        styleName="image"
                      />
                    )}
                  </Grid>
                </Section>
              )}
              <Section id="description">
                <Grid direction="x" gutters="margin">
                  <Cell largeSize={24}>
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                    <br />
                    <Button url={link} color="light" arrow="right">
                      {`${t('See in Store')}`}
                    </Button>
                  </Cell>
                </Grid>
              </Section>
            </>
          )}
        </CenterModal>
      )}
    </>
  );
};

export default ProductOptionModal;
